import React from 'react'
import { Provider } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter as Router } from 'react-router-redux'
import { Helmet } from 'react-helmet'

import AppErrorBoundary from './components/AppErrorBoundary/AppErrorBoundary'
import store from './store'
import Footer from './components/Footer/Footer'
import history from './history'
import HomeScene from './components/HomeScene/HomeScene'
import FutureElectionScene from './components/FutureElectionScene/FutureElectionScene'
import NotFoundScene from './components/NotFoundScene/NotFoundScene'
import PositionScene from './components/PositionScene/PositionScene'
import PositionsScene from './components/PositionsScene/PositionsScene'
import PrivacyScene from './components/PrivacyScene/PrivacyScene'
import ScrollToTop from './components/ScrollToTop/ScrollToTop'
import TermsScene from './components/TermsScene/TermsScene'

// Open Graph image, re-using bg image but might want to use a separate img
import OgImage from './assets/images/bg.jpg'

export default () => (
  <Provider store={store}>
    <Router history={history}>
      <ScrollToTop>
        <Helmet>
          <meta property="og:description" content={process.env.REACT_APP_OG_DESCRIPTION} />
          <meta property="og:image" content={`${process.env.REACT_APP_SITE_URL}${OgImage}`} />
          <meta property="og:title" content={process.env.REACT_APP_OG_TITLE} />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={process.env.REACT_APP_OG_TITLE} />
          <meta name="twitter:description" content={process.env.REACT_APP_OG_DESCRIPTION} />
          <meta name="twitter:image" content={`${process.env.REACT_APP_SITE_URL}${OgImage}`} />
        </Helmet>

        <AppErrorBoundary>
          <Switch>
            <Route exact path="/" component={HomeScene} />
            <Route exact path="/future_election/:year" component={FutureElectionScene} />
            <Route exact path="/positions" component={PositionsScene} />
            <Route exact path="/positions/:positionId" component={PositionScene} />
            <Route exact path="/privacy" component={PrivacyScene} />
            <Route exact path="/terms" component={TermsScene} />

            <Route component={NotFoundScene} />
          </Switch>
        </AppErrorBoundary>

        <Footer />
      </ScrollToTop>
    </Router>
  </Provider>
)



// WEBPACK FOOTER //
// ./src/App.js